import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportData";
import { TradeByClientsReportData } from "../types";

export const useTradeByClientsReportData = () => {
  const data = useSelector<StoreType, TradeByClientsReportData[] | undefined>(
    (s) => s.data.reports.exchbusiness.tradeByClients.data
  );

  const dispatch = useDispatch();
  const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [
    dispatch,
  ]);

  return [data, dispatchLoadData] as [typeof data, typeof dispatchLoadData];
};
